import { render, staticRenderFns } from "./DialogImageLibrary.vue?vue&type=template&id=c0cff096&scoped=true"
import script from "./DialogImageLibrary.vue?vue&type=script&lang=js"
export * from "./DialogImageLibrary.vue?vue&type=script&lang=js"
import style0 from "./DialogImageLibrary.vue?vue&type=style&index=0&id=c0cff096&prod&lang=scss&scoped=true"
import style1 from "./DialogImageLibrary.vue?vue&type=style&index=1&id=c0cff096&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cff096",
  null
  
)

export default component.exports